import { render, staticRenderFns } from "./Saleskanban.vue?vue&type=template&id=aeaaffdc&scoped=true"
import script from "./Saleskanban.vue?vue&type=script&lang=js"
export * from "./Saleskanban.vue?vue&type=script&lang=js"
import style0 from "./Saleskanban.vue?vue&type=style&index=0&id=aeaaffdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeaaffdc",
  null
  
)

export default component.exports